module.exports = __webpack_public_path__ + "img/wellspring.197c3b49.png";